const RETRYABLE_STATUS_CODES = [408, 425, 429, 500, 502, 503, 504]
const RETRYABLE_ERROR_CODES = ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT']

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}

export function isRetryableHttpStatus(status) {
  const normalizedStatus = Number(status)
  if (!Number.isFinite(normalizedStatus)) {
    return false
  }
  return normalizedStatus === 0 || RETRYABLE_STATUS_CODES.includes(normalizedStatus)
}

export function isRetryableAxiosError(error) {
  if (RETRYABLE_ERROR_CODES.includes(error?.code)) {
    return true
  }
  console.log(error, '111111')
  const message = (error?.message || '').toLowerCase()
  if (
    message.includes('network error') ||
    message.includes('failed to fetch') ||
    message.includes('cors') ||
    message.includes('load failed')
  ) {
    return true
  }
  if (!error?.response) {
    return true
  }
  return isRetryableHttpStatus(error.response.status)
}

export async function withRetry(operation, options = {}) {
  const { retries = 2, initialDelayMs = 500, maxDelayMs = 2500, shouldRetry = () => true } = options

  let attempt = 0

  while (attempt <= retries) {
    try {
      return await operation(attempt)
    } catch (error) {
      if (attempt >= retries || !shouldRetry(error, attempt)) {
        throw error
      }
      const delay = Math.min(initialDelayMs * 2 ** attempt, maxDelayMs)
      await sleep(delay)
      attempt += 1
    }
  }
}
